declare var $: any;
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
    public loginErrorMsg1 = '';
    public loginErrorMsg2 = '';

    @ViewChild('emailInput', { static: true }) emailInputRef: ElementRef;
    @ViewChild('passwordInput', { static: true }) passwordInputRef: ElementRef;
    @ViewChild('mEmailInput', { static: true }) mEmailInputRef: ElementRef;

    constructor(private ngZone: NgZone, private router: Router, private authService: AuthService) { }

    ngOnInit() {
    }

    onSignin() {
        const promise = new Promise((resolve, reject) => {
            const email = this.emailInputRef.nativeElement.value;
            const password = this.passwordInputRef.nativeElement.value;
            this.authService.singinUser(email, password).then(
                (data: any) => {
                    this.authService.getLoggedUserData().then(
                        (getLoggedData: any) => {
                            this.ngZone.run(() => this.router.navigate(['home'])).then();
                            resolve(data);
                        },
                        (getLoggedError: any) => {
                            $('#loginErrorModal').modal('show');
                            reject(getLoggedError);
                        }
                    );
                },
                (error: any) => {
                    if (error.error.object.error_description == 'User is locked.') {
                        this.loginErrorMsg1 = 'Your user has been locked. Please click on "Forgot password?" to reset your password or contact support to';
                        this.loginErrorMsg2 = 'support@clicklease.com';
                    } else {
                        this.loginErrorMsg1 = 'The User Name or Password is invalid. Please try again.';
                        this.loginErrorMsg2 = '';
                    }

                    $('#loginErrorModal').modal('show');
                    reject(error);
                }
            );
        });
        return promise;
    }

    onForgotPassword() {
        const promise = new Promise((resolve, reject) => {
            const email = this.mEmailInputRef.nativeElement.value;
            this.authService.sendResetPasswordEmail(email).subscribe(
                data => {
                    $('#forgotPasswordSuccessModal').modal('show');
                    resolve(data);
                },
                error => {
                    $('#forgotPasswordErrorModal').modal('show');
                    reject(error);
                }
            );
        });
        return promise;
    }
}
